import React from "react";
import { Link } from "react-router-dom";
import { Badge, Input, Label, UncontrolledTooltip } from "reactstrap";
import moment from "moment-timezone";

export const selectRow = (props) => ({
  mode: "checkbox",
  clickToSelect: true,
  selectionHeaderRenderer: ({ indeterminate, mode, ...rest }) => (
    <div className="custom-control custom-checkbox">
      <Input
        type="checkbox"
        className="custom-control-input"
        ref={(input) => {
          if (input) input.indeterminate = indeterminate;
        }}
        {...rest}
      />
      <Label className="custom-control-label">&nbsp;</Label>
    </div>
  ),
  selectionRenderer: ({ mode, rowKey, ...rest }) => (
    <div className="custom-control custom-checkbox" key={rowKey}>
      <input type="checkbox" className="custom-control-input" {...rest} />
      <Label className="custom-control-label">&nbsp;</Label>
    </div>
  ),
  ...props,
});

const ListColumns = (toggleDetailsModal, history, t) => [
  {
    text: t("Time"),
    dataField: "created_date",
    sort: true,
    formatter: (_, row) => moment(row.created_date).format("DD MMM YYYY LT"),
  },
  {
    text: t("Type"),
    dataField: "type",
    formatter: (_, row) => <span className="text-capitalize">{row.type}</span>,
  },
  {
    dataField: "amount",
    text: t("Amount"),
  },
  {
    dataField: "senderAccount",
    text: t("sender Account"),
  },
  {
    dataField: "receiverAccount",
    text: t("receiver Account"),
  },
  {
    isDummyField: true,
    text: t("action"),
    dataField: "action",
    formatter: (_, row) => (
      <>
        <Link
          to={`/trasnsaction/${row?._id}/view`}
          className="mr-3 text-secondary"
          onClick={(e) => {
            e.preventDefault();
            toggleDetailsModal(row);
          }}
        >
          <i className="far fa-eye mr-3" id={`view-${row._id}-tooltip`} />
          <UncontrolledTooltip
            placement="top"
            target={`view-${row._id}-tooltip`}
          >
            {t("view_details")}
          </UncontrolledTooltip>
        </Link>
      </>
    ),
  },
];

export default ListColumns;
